export default __webpack_public_path__ + "graphics/android--black.9f5e4665.svg";